<template>
  <div class="calendar-action">
    <v-date-picker
      v-model="value"
      locale="fr"
      mode="single"
      :available-dates="availableDates"
      :min-page="minPage"
      :max-page="maxPage"
      is-inline
      is-expanded />

    <ButtonAction
      class="mt-3"
      :data="{ label: data.label }"
      :is-disabled="isValidationDisabled"
      :is-large="isLarge"
      :is-focused="isFocused"
      @validate="validate" />
  </div>
</template>

<script>
import ButtonAction from "@/components/chatbot/Bubbles/actions/ButtonAction"
import moment from "moment"

export default {
  name: "CalendarAction",
  components: { ButtonAction },
  props: {
    data: {
      type: Object,
      required: true
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: null,
      isFocused: false
    }
  },
  computed: {
    isValidationDisabled() {
      let forCalendar = this.value === null
      return forCalendar
    },
    availableDates() {
      let dates = [... this.data.dates]
      return dates.sort().map(elem => new Date(elem))
    },
    minPage() {
      let dates = this.availableDates
      let date = dates.length ? dates[0] : new Date()
      return {
        month: date.getMonth() + 1,
        year: date.getFullYear() 
      }
    },
    maxPage() {
      let dates = this.availableDates
      let date = dates.length ? dates[dates.length - 1] : new Date()
      return {
        month: date.getMonth() + 1,
        year: date.getFullYear() 
      }
    }
  },
  created() {
    let dates = this.availableDates
    this.value = dates.length ? new Date(dates[0]) : null
  },
  methods: {
    validate() {
      if (!this.value) {
        return
      }

      this.$emit("validate", moment(this.value).format("YYYY-MM-DD"))
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-action {
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
